module.exports = __webpack_public_path__ + "assets/img/02.1b090105.png";